module.exports = __webpack_public_path__ + "img/ssangyong.38e091f7.svg";